import React, { useState } from 'react';
import styles from './BasicTooltip.module.scss';

export type Props = {
    delay?: number;    
    content: any
} & React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLDivElement>, HTMLDivElement>;


const BasicTooltip = (props: Props) => {
  let timeout: any;
  const [active, setActive] = useState(false);

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, props.delay || 400);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  return (
    <div
      className={styles.TooltipWrapper}
      // When to show the tooltip
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {/* Wrapping */}
      {props.children}
      {active && (
        <div className={styles.TooltipTip}>
          <div className={styles.left}>
            <div style={{ position: 'fixed', backgroundColor: 'rgba(0,0,0,0.5)', padding: '10px 25px', borderRadius: 15 }}>
              {props.content}
            </div>
        </div>
        </div>
      )}
    </div>
  );
};

export default BasicTooltip;
